import { render, staticRenderFns } from "./ExpeditionModal.vue?vue&type=template&id=6e32ee22&"
import script from "./ExpeditionModal.vue?vue&type=script&lang=js&"
export * from "./ExpeditionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports